export const GET_CARTS_PENDING = 'GET_CARTS_PENDING'
export const GET_CARTS_SUCCESSFUL = 'GET_CARTS_SUCCESSFUL'
export const GET_CARTS_ERROR = 'GET_CARTS_ERROR'
export const GET_ALL_CART_DEALERS = 'GET_ALL_CART_DEALERS'